// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"657":"8b4292d1","870":"27d741b0","1350":"8b4292d1","2838":"8b4292d1","4044":"08f3d62b","5349":"8b4292d1","7405":"8b4292d1"}[chunkId] + ".chunk.css";
};